export default __webpack_public_path__ + "static/media/loginBackground.9df0959e.png";